import { gql } from '@apollo/client';

export const GQL_MUTATION_CREATE_SUPPORT = gql`
  mutation createSupport ($input: CreateSupportInput!) {
    createSupport(input: $input) {
      id
    }
  }
`;
